(function ($) {
	$.overlayController = function (element, options) {
		// 1**************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			OverlayController = (function ($c, o) {
				var defaults = {
					'baseClass': 'module-overlay',
					'openClass': 'open',
					'controller': new OverlayFaqController($),
					'trigger': null,
					'onInit': function() { _InitOverlayContent(); }
				}; 

				var _o = {},

					$oc = null, // Overlay Container
					$cc = null, // Content Container
					$cbtn = null, // Close Button
					$cbt = null, // Close Button Top Bar
					$cbb = null, // Close Button Bottom Bar

					tln = null, // Timeline

					// FAQs elements
					$fn = null, // FAQ Navigation
					$ft = null // FAQ Terms
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);

					_BuildOverlay();
				},

					_BuildOverlay = function() {
						$oc = $('<div />')
							.addClass(_o.baseClass + '__container')
							.appendTo('body');

						$cc = $('<div />')
							.addClass(_o.baseClass + '__content')
							.appendTo($oc);

						$cbtn = $('<span />')
							.addClass(_o.baseClass + '__close')
							.appendTo($oc);

								$cbt = $('<span />')
									.addClass(_o.baseClass + '__close--bar bar top')
									.appendTo($cbtn);
								$cbb = $('<span />')
									.addClass(_o.baseClass + '__close--bar bar bot')
									.appendTo($cbtn);
					},

				_BindEvents = function () {
					_BuildTimeline();

					$c.click(_OnTriggerClick);
					$cbtn.click(_OnCloseClick);
				},

					_BuildTimeline = function() {
						tln = new TimelineLite({ paused: true });

						tln
							.add('close')
							.add(new TweenMax($cbt, 1, { css: { opacity: 1, rotation: 45 }, ease: Power4.easeInOut }), 'close')
							.add(new TweenMax($cbb, 1, { css: { opacity: 1, rotation: -45 }, ease: Power4.easeInOut }), 'close')
						;
					}

					_OnTriggerClick = function(e) {
						e.preventDefault();
						_o.trigger = e.currentTarget.hash;

						$oc.fadeIn(500, 'swing', function() {
							tln.play();
						});

						_o.controller.init($cc, _o);
					},

					_OnCloseClick = function(e) {
						e.preventDefault();
						tln.reverse().timeScale(1.5);
						setTimeout(function() {
							$oc.fadeOut();
						}, 500);
					},

				_InitOverlayContent = function() {
					var $l = $('.close-overlay', $cc);
					$l.click(_OnCloseClick);
					$('.smooth', $cc).smoothScroll();
				};

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.overlayController = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('overlayController')) {
				var plugin = new $.overlayController(this, options);
				$(this).data('overlayController', plugin);
			}
		});
	};
})(jQuery);
